import {addStep} from 'operations/actions.js';

export function pasteKillRing(sequencerEngine, killRing) {
    let track = sequencerEngine.getSelectedTrack();
    let stepNumber = sequencerEngine.cursor.step;

    // adjust step number to fit the new steps
    let minStepNumber = Math.min(... killRing.map(x => x.stepNumber));
    killRing = killRing.map(s => ({
        ... s,
        stepNumber: stepNumber + s.stepNumber - minStepNumber
    }));

    let op = sequencerEngine.operationManager;
    killRing.forEach(
        s =>
            op.dispatch(addStep(
                track,
                s.step.getCopy(true, false, true, false, false),
                s.stepNumber)));
    track.updateSteps();
}
